import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { UpdateWebhook } from '@cast/types';

import { getWebhooksQueryKey } from 'hooks/queries/notifications/useGetWebhooksQuery';

export const useUpdateWebhookMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, webhook }: { id: string; webhook: UpdateWebhook }) => {
      return apiClient.notifications.updateWebhook({ id, config: webhook });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getWebhooksQueryKey() });
      notify.success('Webhook updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
